import React, { useState,useContext ,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX ,faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import OtherDetails from '../Components/OtherDetails';
import Address from '../Components/Address';
import ContactPersons from '../Components/ContactPersons';
import { Loader ,Spinner } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages';
import {  useLocation } from 'react-router-dom'


function NewCustomer() {
  const location = useLocation();

  const navigate = useNavigate();
  const [showOtherDetails, setShowOtherDetails] = useState(true);
  const [showAddress, setShowAddress] = useState(false);
  const [showContactPersons, setShowContactPersons] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
const [popupMessage, setPopupMessage] = useState('');
const [popupType, setPopupType] = useState('');
const [errors, setErrors] = useState({ email:'', mobile_number: '',gstin: '', pan: '' });
  const fetchUrl = process.env.REACT_APP_FORE_KRAFTO;
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const [retryFunction, setRetryFunction] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [sidebarClicked, setSidebarClicked] = useState(false)

  const [data, setData] = useState({
    mobile_number: '',
    email: '',
    customer_name: '',
    company_name: '',
    type_of_firm: '',
    gstin: '',
    pan: '',
    city: '',
    association: '',
    address: '',
    state:''
  });

  const [otherDetails, setOtherDetails] = useState({
    gstin: '',
    pan: '',
    city: '',
    state:''
  });

  const [address, setAddress] = useState({
    address: '',
    city: '',
    state: '',
    pincode: '',
  });

  const [contactPersons, setContactPersons] = useState([
    { name: '', email: '', mobile_number: '', designation: '' }
  ]);


 
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // General validation for all fields
    if (name === 'mobile_number') {
      if (value.length > 10) {
        return; 
      } 
      // Check if first digit is valid (6,7,8,9)
  if (value.length === 1 && !['6','7','8','9'].includes(value)) {
    setErrors((prevState) => ({ 
      ...prevState, 
      mobile_number: 'Mobile number must start with 6, 7, 8 or 9' 
    }));
    return;
  }
      if (!/^[0-9]*$/.test(value)) {
        return;
      }
      setData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      if (value.length < 10 && value.length > 0) {
        setErrors((prevState) => ({ ...prevState, mobile_number: 'Enter 10 Digits Mobile Number please' }));
      } else {
        setErrors((prevState) => ({ ...prevState, mobile_number: '' }));
      }
    }
  
    if (name === 'email') {
      if (value === '') {
        setErrors((prevState) => ({ ...prevState, email: '' })); // Clear error message if email field is empty
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          setErrors((prevState) => ({ ...prevState, email: 'Please enter a valid email address' }));
        } else {
          setErrors((prevState) => ({ ...prevState, email: '' }));
        }
      }
      setData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  
    // Handle changes for other fields
    if (name === 'customer_name' || name === 'company_name' || name === 'type_of_firm' || name === 'association' ) {
      setData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      
    }
  };

  const handleChangeOtherDetails = (e) => {
    const { name, value } = e.target;

    // Prevent GSTIN from exceeding 15 characters
    if (name === 'gstin' && value.length > 15) {
      return;
    }

    // Prevent PAN from exceeding 10 characters
    if (name === 'pan' && value.length > 10) {
      return;
    }

    // Validate GSTIN
    if (name === 'gstin') {
      if (value === '') {
        setErrors((prevState) => ({ ...prevState, gstin: '' }));
      } else {
        const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        if (!gstinRegex.test(value)) {
          setErrors((prevState) => ({ ...prevState, gstin: 'Invalid GSTIN format' }));
        } else {
          setErrors((prevState) => ({ ...prevState, gstin: '' }));
        }
      }
    }

    // Validate PAN
    if (name === 'pan') {
      if (value === '') {
        setErrors((prevState) => ({ ...prevState, pan: '' }));
      } else {
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (!panRegex.test(value)) {
          setErrors((prevState) => ({ ...prevState, pan: 'Invalid PAN format' }));
        } else {
          setErrors((prevState) => ({ ...prevState, pan: '' }));
        }
      }
    }

    setOtherDetails((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleDropdownChange = (value) => {
    setOtherDetails((prevDetails) => ({
      ...prevDetails,
      state: value,
    }));
  };

  const handleAddressDropdownChange = (value) => {
    setAddress((prevDetails) => ({
      ...prevDetails,
      state: value,
    }));
  }; 


  const handleChangeAddress = (e) => {
    const { name, value } = e.target;
    setAddress((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleChangeContact = (updatedContacts) => {
    setContactPersons(updatedContacts);
  };

  const addContactPerson = () => {
    setContactPersons([...contactPersons, { name: '', email: '', mobile_number: '', designation: '' }]);
  };

  const removeContactPerson = (index) => {
    const updatedContacts = contactPersons.filter((_, i) => i !== index);
    setContactPersons(updatedContacts);
  };


  const handleSubmit = async (attempt = 1) => {
    const errorMessages = [];
    if (!data.customer_name) {
      errorMessages.push('Enter the Name of your Customer.');
    }
  if (!data.mobile_number || data.mobile_number.length !== 10 || !/^[0-9]+$/.test(data.mobile_number)) {
    errorMessages.push('Enter a valid 10-digit Mobile Number.');
  }
  if (data.email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data.email)) {
      errorMessages.push('Please enter a valid email address.');
    }
  }  
    if (!otherDetails.gstin) {
      errorMessages.push('Please enter the GST.');
    } else {
      const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (!gstinRegex.test(otherDetails.gstin)) {
        errorMessages.push('Invalid GSTIN format.');
      }
    }
    if (!otherDetails.pan) {
      errorMessages.push('Please enter the PAN.');
    } else {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      if (!panRegex.test(otherDetails.pan)) {
        errorMessages.push('Invalid PAN format.');
      }
    }
    if (errorMessages.length > 0) {
      setErrorMessages(errorMessages);
      return;
    }
    setIsSaving(true);
    try {
      const token = sessionStorage.getItem('token');
      const saveUrl = `${fetchUrl}customer/create-customer`;
      const addressString = `${address.address} ${address.city} ${address.state} ${address.pincode}`;
      const requestData = {
        ...data,
        gstin: data.gstin || otherDetails.gstin,
        pan: data.pan || otherDetails.pan,
        city: data.city || otherDetails.city,
        state:data.state || otherDetails.state,
        address: addressString,
        //organizationId: sessionStorage.getItem('organizationId'), 
        ...(contactPersons?.[0]?.mobile_number !== '' && { customerContacts: contactPersons }),

      };
      const response = await fetch(saveUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify(requestData),
      });
      const responseData = await response.json();
      console.log(responseData)
      if (responseData.status === 201 || responseData.status === 200 || responseData.status === 204) {
        setIsSaving(false);
        setPopupMessage(responseData.message);
        setPopupType('200or201');
        setShowPopup(true);
        setTimeout(() => {
          setShowPopup(false);
          navigate("/krafto/app/sales/customerdetails", {state:{CustomerData:responseData.data}})
        }, 3000); 
        
       } else if (responseData.status === 400) {
        setIsSaving(false);
        setPopupMessage(responseData.message);
        setPopupType('400');
        setShowPopup(true);
      } else if (responseData.status === 401) {
        setIsSaving(false);
        setPopupMessage(responseData.message);
        setPopupType('401');
        setShowPopup(true);
      } else if (responseData.status === 403) {
        setIsSaving(false);
        setPopupMessage(responseData.message);
        setPopupType('403');
        setShowPopup(true);
      } else if (responseData.status === 500) {
        setIsSaving(false);
        setPopupMessage(responseData.message);
        setPopupType('500');
        setShowPopup(true);
      } else {
        setIsSaving(false);
        setPopupMessage('Unknown error');
        setPopupType('500');
        setShowPopup(true);
      }
    }  catch (error) {
      console.error('Failed to fetch:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => handleSubmit(attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => handleSubmit(attempt)); // Set retry function
      }
    } finally {
      setErrorMessages([]);
    }
  };


  if (isLoading) {
    return <Loader />;
  }

  const handleCloseError = () => {
    setErrorMessages([]);
  };

  const closePopup = () => {

    setShowPopup(false);
  };
  
  const Retry = async () => {

    setIsLoading(true); // Show loader
    setTimeout(async () => {
      if (retryFunction) {
        await retryFunction(); // Call retry function
      }
      setIsLoading(false); // Hide loader after retry
    }, 5000); // 5-second delay
    setShowPopup(false);
  };
  
  const BackToLoginPage = () => {

    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/krafto');
  };

  const handleCancel = () =>  {
      setShowCancelPopup(true)

  };
  const handleStayHere = () => {
    setShowCancelPopup(false);

  };
  
  const handleLeave = () => {
    setShowCancelPopup(false);  
    navigate(-1);
    
  };
    return (
    <div className="bg-white flex flex-row w-full justify-left h-full overflow-y-hidden">
      <div className="flex flex-row w-full">
        <div className="w-full flex-1">
          <div className="flex flex-col w-full h-full justify-center items-center">
            <div className="w-full h-full flex flex-col justify-between">
              <div className="w-full h-16 border-b flex items-center">
                <div className="flex w-full justify-between px-4 items-center">
                  <h1 className="text-lg font-semibold">New Customer</h1>
                </div>
              </div>
              {errorMessages.length > 0 && (
                <div className="flex justify-between items-center  px-auto py-3  bg-[#fddcde]  rounded-md">
                  <div className="px-6 flex flex-col justify-start items-start">
                    {errorMessages.map((errorMessage, index) => (
                      <span key={index} className="text-sm">
                         •   {errorMessage}
                      </span>
                    ))}
                  </div>
                  <div className='px-4'>
                  <button
                    className="text-gray-700 hover:text-red-500"
                    onClick={handleCloseError}
                  >
                    <FontAwesomeIcon icon={faX} className="text-xs text-[#b79860] cursor-pointer" />
                  </button>
                  </div>
                </div>
              )}
              <div className="flex flex-col justify-start items-start w-full flex-grow h-80 overflow-y-auto">
                <div className="w-full flex flex-col justify-start items-start px-4">
                  {/* Customer Name Label and Input */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="customerName" className="block text-sm font-regular text-[#e54643] w-1/6">
                      Customer Name<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="customerName"
                      name="customer_name"
                      value={data.customer_name}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                  </div>

                  {/* Company Name Label and Input */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="companyName" className="block text-sm font-regular text-gray-700 w-1/6">
                      Company Name
                    </label>
                    <input
                      type="text"
                      id="companyName"
                      name="company_name"
                      value={data.company_name}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                  </div>

                  {/* Company Type Dropdown */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="companytype" className="block text-sm font-regular text-gray-700 w-1/6">
                      Company Type
                    </label>
                    <select
                      id="companytype"
                      name="type_of_firm"
                      value={data.type_of_firm}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    >
                      <option value="">Select Company Type</option>
                      <option value="private">Private</option>
                      <option value="public">Public</option>
                      <option value="partnership">Partnership</option>
                      <option value="soleproprietorship">Sole Proprietorship</option>
                      {/* Add more options as needed */}
                    </select>
                  </div>

                  {/* Association Dropdown */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="association" className="block text-sm font-regular text-gray-700 w-1/6">
                      Association
                    </label>
                    <select
                      id="association"
                      name="association"
                      value={data.association}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    >
                      <option value="">Select Association</option>
                      <option value="naredco">NAREDCO</option>
                      <option value="credai">CREDAI</option>
                      <option value="bai">BAI</option>
                      {/* Add more options as needed */}
                    </select>
                  </div>

                  {/* Email Label and Input */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="email" className="block text-sm font-regular text-gray-700 w-1/6">
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={data.email}
                      onChange={handleChange}
                     className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                    {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
                  </div>

                  {/* Mobile Label and Input */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="mobile" className="block text-sm font-regular text-[#e54643] w-1/6">
                      Mobile*
                    </label>
                    <input
                      type="text"
                      id="mobile"
                      name="mobile_number"
                      value={data.mobile_number}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                    {errors.mobile_number && <p className="text-red-500 text-sm">{errors.mobile_number}</p>}
                  </div>

                  <div className='flex w-full items-center border-b'>
                    <div className="w-full flex flex-row space-x-2">
                      <button
                        className={`w-1/6 p-2 text-sm ${showOtherDetails ? 'text-[#21263C] font-medium border-b-2 border-blue-500' : ''}`}
                        onClick={() => {
                          setShowOtherDetails(true);
                          setShowAddress(false);
                          setShowContactPersons(false);
                        }}
                      >
                        Other Details
                      </button>
                      <button
                        className={`w-1/6 p-2 text-sm ${showAddress ? 'text-[#21263C] font-medium border-b-2 border-blue-500' : ''}`}
                        onClick={() => {
                          setShowOtherDetails(false);
                          setShowAddress(true);
                          setShowContactPersons(false);
                        }}
                      >
                        Address
                      </button>
                      <button
                        className={`w-1/6 p-2 text-sm ${showContactPersons ? 'text-[#21263C] font-medium border-b-2 border-blue-500' : ''}`}
                        onClick={() => {
                          setShowOtherDetails(false);
                          setShowAddress(false);
                          setShowContactPersons(true);
                        }}
                      >
                        Contact Persons
                      </button>
                    </div>
                  </div>

                  {/* Other Details Section */}
                  {showOtherDetails &&  <OtherDetails
          gstin={otherDetails.gstin}
          pan={otherDetails.pan}
          city={otherDetails.city}
          state={otherDetails.state}
          onChange={handleChangeOtherDetails}
          errors={errors}
          updateState={handleDropdownChange}
        />}

                  {/* Address Section */}
                  {showAddress && <Address
          address={address.address}
          city={address.city}
          state={address.state}
          pincode={address.pincode}
          onChange={handleChangeAddress}
          updateAddressState={handleAddressDropdownChange}
        />}
                  {/* Contact Persons Section */}
                  {showContactPersons && <ContactPersons
                  contactPersons={contactPersons}
                  onChange={handleChangeContact}
                  addContactPerson={addContactPerson}
                  removeContactPerson={removeContactPerson}
                />
                }
                </div>
                </div>
                <div className="mt-5 w-full">
                  <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
                  <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
                    <button className="px-2 py-1 bg-[#b79860] border-[#b79860] text-white rounded-md space-x-2 flex items-center" onClick={handleSubmit}>
                      <span>Save</span>
                      {isSaving && <Spinner />}
                    </button>
                    <button  className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
          isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
        }`}
        disabled={isSaving}
         onClick={handleCancel}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
         
        </div>
      </div>

      {showCancelPopup && (
    <div className="fixed inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50 ">
    <div className="bg-white rounded-b-md shadow-md w-[550px] h-[250px] flex flex-col" style={{ maxWidth: '550px', maxHeight: '250px' }}>
    <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-14 px-6'>
    <h2 className="text-md font-semibold">
    <FontAwesomeIcon icon={faExclamationTriangle} className="text-xl text-yellow-500 mr-4 " />
      Leave this page?</h2>
      <button onClick={handleStayHere} className="text-white px-1 py-1 rounded-md ">   
        <FontAwesomeIcon icon={faX} className="text-xs text-[#212529] cursor-pointer " />
      </button>
    </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      <div className='pt-4 pl-4 '>
    <div className="w-full items-center p-5">
      <label htmlFor="Other_details" className="block text-sm font-regular text-[#212529] ">
      If you leave, your unsaved changes will be discarded.
      </label>
    </div>  
  </div>
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="text-sm flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
        <button className="px-2 py-1 bg-[#408dfb] border-[#b79860] text-white rounded-md" onClick={handleStayHere}>
  Stay Here  {isSaving && (
      <Spinner/>
    )}
  </button>
          <button onClick={handleLeave} 
          className="hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50  px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md">
            Leave & Discard Changes</button>
        </div>
      </div>
    </div>
  </div>
)}
      {showPopup && (
  <div>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
  </div>
)}
    </div>
  );
}

export default NewCustomer;
